import * as amplitude from '@amplitude/analytics-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';
import { detectApplicationName } from '../utils/applicationName';
import { detectPlatformOs } from '../utils/platformOs';

// TODO: Review this implementation
const analytics = (amplitudeKey) => {
  // Common props are sent with every single amplitude event.
  const applicationName = detectApplicationName();
  const commonProps = {
    platform_os: detectPlatformOs(),
    client_id: null,
    ...(applicationName ? { application_name: applicationName } : {}),
  };

  return {
    init: function init(user) {
      const isImpersonating = user?.impersonated_nav_info?.show;
      const userId = isImpersonating
        ? user?.pendo_setup?.visitor?.id
        : user?.sub?.split(':').at(-1);

      // Sample Rate 0.1 = 10%, 1 = 100%
      // https://amplitude.com/docs/session-replay/session-replay-standalone-sdk
      // const sampleRate = import.meta.env.PROD ? 0.1 : 100;
      const sessionReplayTracking = sessionReplayPlugin({ sampleRate : 0.1 });
      amplitude.add(sessionReplayTracking);

      amplitude.init(amplitudeKey, userId, { defaultTracking: true, sessions: true });
      if (userId) {
        commonProps.client_id = user?.client;
        const identifyEvent = new amplitude.Identify();
        identifyEvent.set('client_id', user?.client);
        identifyEvent.set('announcements_sms_status', userHasSmsAnnouncementsEnabled(user));
        identifyEvent.set('user_type', getRoomsUserType(user));
        amplitude.identify(identifyEvent);
      }
    },
    initWithId: function initWithId(userId, clientId) {
      const sessionReplayTracking = sessionReplayPlugin({ sampleRate : 0.1 });
      amplitude.add(sessionReplayTracking);

      amplitude.init(amplitudeKey, userId, { defaultTracking: true, sessions: true });
      commonProps.client_id = clientId;
      const identifyEvent = new amplitude.Identify();
      identifyEvent.set('client_id', clientId);
      amplitude.identify(identifyEvent);
    },
    setCommonProperty: (name, value) => { commonProps[name] = value; },
    removeCommonProperty: (name) => { commonProps[name] = null; },
    // amplitude.track() returns { promise } rather than a real Promise; unwrap it here
    // so every call site can just `await $analytics.track(...)`.
    track: (eventName, eventProps) => amplitude.track(eventName, { ...commonProps, ...eventProps })?.promise,
  };
};

const userHasSmsAnnouncementsEnabled = (user) => {
  return !!user?.notification_preferences?.find(np => np.service === 'rooms-announcements' && np.channel === 'sms' && np.enabled);
}

const getRoomsUserType = (user) => {
  return user?.roles?.rooms || 'staff';
}

export default (object) => {
  const amplitudeKey = document.getElementById('amplitude-key').value;
  if (!amplitudeKey) return;
  object.config.globalProperties.$analytics = analytics(amplitudeKey);
};
